import { render, staticRenderFns } from "./choiceContract-v2.vue?vue&type=template&id=7f20b312&scoped=true&"
import script from "./choiceContract-v2.vue?vue&type=script&lang=js&"
export * from "./choiceContract-v2.vue?vue&type=script&lang=js&"
import style0 from "./choiceContract-v2.vue?vue&type=style&index=0&id=7f20b312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20b312",
  null
  
)

export default component.exports